import React from 'react';
import { getThemeColors } from '../../../../lib/theme';
import type { DashboardData } from '../types';

interface PipelineWidgetProps {
  mode: 'full' | 'summary';
  dark: boolean;
  data: DashboardData | null;
  tr: (k: string) => string;
}

export function PipelineWidget({ mode, dark, data, tr }: PipelineWidgetProps) {
  const t = getThemeColors(dark);
  const phases = data?.phaseCounts ?? [];
  const max = Math.max(1, ...phases.map(p => p.count));

  if (mode === 'summary') {
    return (
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {phases.map(p => (
          <div key={p.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 60 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: t.heading }}>{p.count}</div>
            <div style={{ fontSize: 10, color: t.muted }}>{p.title}</div>
          </div>
        ))}
        {!data && <span style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.loading')}</span>}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {phases.map(p => (
        <div key={p.id}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: t.text, marginBottom: 4 }}>
            <span>{p.title}</span>
            <span style={{ color: t.muted }}>{p.count}</span>
          </div>
          <div style={{ height: 7, background: t.chipBg, borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${(p.count / max) * 100}%`, background: p.color, borderRadius: 4 }} />
          </div>
        </div>
      ))}
      {!data && <div style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.loading')}</div>}
      {data && phases.length === 0 && (
        <div style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.pipeline.empty_phases')}</div>
      )}
    </div>
  );
}
